import React from "react";
import {Dictionary} from "../Dictionary";
import {SysButton} from "../Elements/SysButton";
import {RightAside} from "../Aside/RightAside";

export class FormSubmit extends React.Component<any, any> {
    protected dictionary: Dictionary = new Dictionary();

    render() {
        let label = this.props.label || this.dictionary.get['save'];

        return (
            <>
                {this.props.aside && <div className="form-group">
                    <div className="alert alert-info hide" role="alert">
                        {this.dictionary.get['loading']}...
                    </div>
                    <div className="alert alert-success hide" role="alert">
                        {this.dictionary.get['success-save']}
                    </div>
                    <div className="alert alert-danger hide" role="alert">
                        {this.dictionary.get['unknown-error']}
                    </div>
                </div>}
                <div className="form-group">
                    {!this.props?.nosubmit &&
                        <button type="submit" className="btn btn-sm btn-success">
                            {label}
                        </button>}
                    {this.props.aside &&
                        <SysButton className="closeRightAside" type={'SignTurnRightFill'}
                                   text={this.dictionary.get['close']} onClick={RightAside.close}/>}
                </div>
                {!this.props.aside && <div className="form-group">
                    <div className="alert alert-success hide" role="alert">
                        {this.dictionary.get['success-save']}
                    </div>
                    <div className="alert alert-danger hide" role="alert">
                        {this.dictionary.get['unknown-error']}
                    </div>
                </div>}
            </>
        );
    }
}